import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * `text-caption` is a custom Tailwind v4 size (`--text-caption`, declared by
 * both apps' globals). Stock `tailwind-merge` does not treat it as a
 * font-size, so `cn('text-sm', 'text-caption')` would keep both and
 * `text-sm` would win. Registering it on the `text` scale is what lets the
 * compact chrome overrides (`Button size="xs"`, `Badge`, `CommandItem`,
 * `SelectItem`) actually apply. The one copy both apps import since the
 * lib/utils.ts split (#1253) — do not re-fork it into either tree.
 *
 * The motion tokens (motion.css) get the same treatment: `duration-fast` and
 * `ease-smooth-out` are unknown to stock tailwind-merge, so a caller's
 * `duration-100` would not replace a primitive's `duration-fast`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['caption'],
      ease: ['smooth-out', 'bounce', 'bounce-strong'],
    },
    classGroups: {
      duration: [
        {
          duration: ['micro', 'quick', 'fast', 'medium', 'slow', 'very-slow'],
        },
      ],
    },
  },
})

export function cn(...inputs: Array<ClassValue>): string {
  return twMerge(clsx(inputs))
}
